/*
 * @描述:
 * @作者: lidong
 * @时间: Do not edit
 * @最后更新时间: Do not edit
 * @更新: lidong
 * @参考:
 */
// 初始化数据
const modal = {
  TempVisable: false, //显示配送模板弹框
  TableVisable: false, // 显示商品列表弹框
  editTemp: {}, //修改配送模板数据
  searchResult: [], //查询结果数据
  modTabpsearchResult: [], //查看商品列表
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  pageNum: 1, // 当前页码
  pageSize: 10, // 当前分页数
  configKey: 0, //配送模板限制类型
  modTabpageNum: 1, // 查看商品列表当前页码
  modTabpageSize: 10, // 查看商品列表当前分页数
  modTabptotal: 0, // 查看商品列表查询总数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  superClass: 0, //工具栏按钮
  selectedRowKeys: [], //选择的行
  deliverNo: '',
  deliverName: '',
  regionData: [],
  distributionArea: 'china',
  undistributionArea: 'usa',
  tabList: [
    { name: '待发货', num: '' },
    { name: '已发货', num: '' },
    { name: '已签收', num: '' },
    { name: '已取消', num: '' },
  ],
  totalAmount: {},
  orderStatusList: [
    { name: '所有订单', key: '1' },
    { name: '未出库', key: '2' },
    { name: '已出库', key: '3' },
    { name: '已取消', key: '4' },
  ],
  cityData: [],
  deliveryId: '',
  submitLoading: false,
};
export default modal;
